"use strict";

exports.__esModule = true;
exports.X_AXIS_LINE_WIDTH = exports.WORD_CLOUD_MIN_FONT_SIZE = exports.WORD_CLOUD_MAX_FONT_SIZE = exports.POINT_LABEL_FONT_WEIGHT = exports.MARKER_SERIES_SELECT_RADIUS = exports.MARKER_SERIES_SELECT_LINE_WIDTH = exports.MARKER_SERIES_SELECT_LINE_COLOR = exports.LINE_AND_TICK_COLOR = exports.LEGEND_PADDING = exports.LEGEND_LABEL_FONT_WEIGHT = exports.LEGEND_LABEL_FONT_SIZE = exports.LEGEND_LABEL_FONT_COLOR = exports.FONT_WEIGHT = exports.FONT_FAMILY = exports.DEFAULT_SERIES_CHART_COLORS = exports.DEFAULT_DATALABEL_WEIGHT = exports.DEFAULT_DATALABEL_COLOR = exports.CURSOR_POINTER = exports.CURSOR_DEFAULT = exports.COLUMN_SELECT_BORDER_WIDTH = exports.AXIS_LABEL_FONT_WEIGHT = exports.AXIS_LABEL_FONT_COLOR = void 0;
var AXIS_LABEL_FONT_COLOR = '#757575';
exports.AXIS_LABEL_FONT_COLOR = AXIS_LABEL_FONT_COLOR;
var AXIS_LABEL_FONT_WEIGHT = '400';
exports.AXIS_LABEL_FONT_WEIGHT = AXIS_LABEL_FONT_WEIGHT;
var COLUMN_SELECT_BORDER_WIDTH = '0';
exports.COLUMN_SELECT_BORDER_WIDTH = COLUMN_SELECT_BORDER_WIDTH;
var CURSOR_DEFAULT = 'default';
exports.CURSOR_DEFAULT = CURSOR_DEFAULT;
var CURSOR_POINTER = 'pointer';
exports.CURSOR_POINTER = CURSOR_POINTER;
var DEFAULT_DATALABEL_COLOR = '#212121';
exports.DEFAULT_DATALABEL_COLOR = DEFAULT_DATALABEL_COLOR;
var DEFAULT_DATALABEL_WEIGHT = 'normal';
exports.DEFAULT_DATALABEL_WEIGHT = DEFAULT_DATALABEL_WEIGHT;
var DEFAULT_SERIES_CHART_COLORS = ['#0194EB', '#FFBC45', '#F65D8B', '#1DD1A1', '#FF7845', '#545454', '#96497B', '#3E9189', '#956445', '#3B5C87'];
exports.DEFAULT_SERIES_CHART_COLORS = DEFAULT_SERIES_CHART_COLORS;
var FONT_FAMILY = '"Helvetica Neue", Helvetica, Arial, sans-serif';
exports.FONT_FAMILY = FONT_FAMILY;
var FONT_WEIGHT = '500';
exports.FONT_WEIGHT = FONT_WEIGHT;
var LEGEND_LABEL_FONT_COLOR = '#757575';
exports.LEGEND_LABEL_FONT_COLOR = LEGEND_LABEL_FONT_COLOR;
var LEGEND_LABEL_FONT_SIZE = '11px';
exports.LEGEND_LABEL_FONT_SIZE = LEGEND_LABEL_FONT_SIZE;
var LEGEND_LABEL_FONT_WEIGHT = 'normal';
exports.LEGEND_LABEL_FONT_WEIGHT = LEGEND_LABEL_FONT_WEIGHT;
var LEGEND_PADDING = 4;
exports.LEGEND_PADDING = LEGEND_PADDING;
var LINE_AND_TICK_COLOR = '#E0E0E0';
exports.LINE_AND_TICK_COLOR = LINE_AND_TICK_COLOR;
var MARKER_SERIES_SELECT_LINE_COLOR = '#FF477533';
exports.MARKER_SERIES_SELECT_LINE_COLOR = MARKER_SERIES_SELECT_LINE_COLOR;
var MARKER_SERIES_SELECT_LINE_WIDTH = 5;
exports.MARKER_SERIES_SELECT_LINE_WIDTH = MARKER_SERIES_SELECT_LINE_WIDTH;
var MARKER_SERIES_SELECT_RADIUS = 8;
exports.MARKER_SERIES_SELECT_RADIUS = MARKER_SERIES_SELECT_RADIUS;
var POINT_LABEL_FONT_WEIGHT = 'bold';
exports.POINT_LABEL_FONT_WEIGHT = POINT_LABEL_FONT_WEIGHT;
var WORD_CLOUD_MAX_FONT_SIZE = 24;
exports.WORD_CLOUD_MAX_FONT_SIZE = WORD_CLOUD_MAX_FONT_SIZE;
var WORD_CLOUD_MIN_FONT_SIZE = 12;
exports.WORD_CLOUD_MIN_FONT_SIZE = WORD_CLOUD_MIN_FONT_SIZE;
var X_AXIS_LINE_WIDTH = 1;
exports.X_AXIS_LINE_WIDTH = X_AXIS_LINE_WIDTH;